
import { defineComponent, ref } from "vue";
import { hideModal } from "@/core/helpers/dom";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";

export default defineComponent({
  name: "delete-funding-round-modal",
  components: {},
  props: {
    id: {
      required: true,
      type: Number,
    },
    businessId:{
      required: true,
      type: Number
    }
  },
  setup(props, {emit}) {
    const store = useStore();
    const fundingRoundId = ref<number>(props.id);
    const formRef = ref<null | HTMLFormElement>(null);
    const newTargetModalRef = ref<null | HTMLElement>(null);
    const loading = ref<boolean>(false);

    const submit = async () => {
      if (!formRef.value) {
        return;
      }
      loading.value = true;
      try {
        const response = await store.dispatch(
          Actions.DELETE_FUNDING_ROUND,
          fundingRoundId.value
        );
        loading.value = false;
        if (response !== true) throw new Error();
        emit("round-deleted")

        store.commit("setAlert", {
              message: "Success",
              subMessage: "Funding Round has been deleted successfully!",
              variant: "primary",
              duration: 4000,
              show: true,
            });
            hideModal(newTargetModalRef.value);
 
      } catch (err) {
        store.commit("setAlert", {
              message: "Error",
              subMessage: "Sorry, looks like there are some errors detected, please try again.",
              variant: "danger",
              duration: 4000,
              show: true,
            });
        return false;
      }
    };

    return {
      fundingRoundId,
      submit,
      loading,
      formRef,
      newTargetModalRef,
    };
  },
});
